module.exports = __webpack_public_path__ + "img/image165.60216573.jpg";